import { Outlet, useNavigate } from "react-router-dom";
import ScrollTop from "../Components/ScrollTop/ScrollTop";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import useCheckForXSS from "../Hooks/useCheckForXSS";
import { useEffect } from "react";

const AppLayout = () => {
  const isSuspicious = useCheckForXSS();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSuspicious) {
      navigate("/not-found", { replace: true });
    }
  }, [isSuspicious, navigate]);

  if (isSuspicious) return null;
  return (
    <>
      <Navbar />
      <ScrollTop />
      <Outlet />
      <Footer />
    </>
  );
};

export default AppLayout;
